export default __webpack_public_path__ + "static/media/dashboard-prestations.7412b53b.svg";